/*---scripts.js----*/
$('.product__media-list').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  arrows: false,
  asNavFor: '.product_nav_slide'
});
$('.product_nav_slide').slick({
  arrows: true,
  slidesToShow:5,
  slidesToScroll: 1,
  infinite: false,
  asNavFor: '.product__media-list',
  focusOnSelect: true,
  responsive: [{
    breakpoint: 768,
    settings: {
      slidesToShow: 4
    }
  }]
}); 
$(document).ready(function(){
  $('.tab_item:first .tab_link').click();
  $('.app_items_list').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    variableWidth:true,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        variableWidth:false,
        centerMode: true,
        centerPadding: '60px',
        slide: 'li'
      }
    },
                 {
                   breakpoint: 480,
                   settings: {
                     slidesToShow: 1,
                     variableWidth:false,
                     centerMode: true,
                     centerPadding: '40px',
                   }
                 }]
  });
  var h3height = 0;
  $('.blog_wrapper').each(function() {
    if(h3height < $(this).outerHeight()){
      h3height = $(this).outerHeight();
    };
  });
  $('.blog_wrapper').height(h3height);
  $('.testim_review_dv').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    },
                 {
                   breakpoint: 576,
                   settings: {
                     slidesToShow: 1
                   }
                 }]
  });  
  $('[download]').on('click', function (e) {
    e.preventDefault(); var link = $(this).attr('href');
    $.ajax({
      url: link,
      method: 'GET',
      xhrFields: {
        responseType: 'blob'
      },
      success: function (data) {
        var a = document.createElement('a');
        var url = window.URL.createObjectURL(data);
        a.href = url;
        a.download = '';
        document.body.append(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }
    });
  });
  $('.nav_link, .footer_link').each(function(){
    var data_id = $(this).attr('href');
    var url_loc = window.location.href.split('#');
    if (url_loc[1]){
      if ('#'+url_loc[1] == data_id){
        $('a[href="'+data_id+'"]').addClass('active').parents('li').siblings().find('a').removeClass('active');
      }
    }
  });
});
if ($(window).width() >= 480){
  $(document).on('click', '.tab_item a', function(){
    $('.tab_content').slideUp();
    var href_val = $(this).attr('href');  
    $(this).addClass('active').parents('.tab_item').siblings().find('a').removeClass('active');
    $(href_val).slideToggle();
    return false;
  });
}
$(document).on('click', '.faq_header', function(){
  $(this).toggleClass('active').parents('.faq_icon_item').siblings().find('.faq_header').removeClass('active');
  $(this).parents('.faq_icon_item').find('.faq_body').slideToggle().parents('.faq_icon_item').siblings().find('.faq_body').slideUp();
});
if ($(window).width() <= 479){
  $(document).on('click', '.tab_link', function(){
    $(this).toggleClass('active').parents('.tab_item').siblings().find('.tab_link').removeClass('active');
    $(this).parents('.tab_item').find('.accordion_tab_body').slideToggle().parents('.tab_item').siblings().find('.accordion_tab_body').slideUp();
    return false;
  });
}
var btn = $('.back_to_top');
$(window).scroll(function() {
  if ($(window).scrollTop() > 700) {
    btn.removeClass('show');
  } else {
    btn.addClass('show');
  }
});
btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});
$(document).on('click', '.btn_play', function(){
  $('#sample_video').trigger('play').attr('controls', 'true');
  $(this).hide();
});
var header_height = $('header').innerHeight();
$(document).on('click', '.nav_link, .footer_link', function(){
  var data_id = $(this).attr('href');   
  $('.menu-drawer-container').removeClass('menu-opening').removeAttr('open');
  $('body').removeClass('overflow-hidden-tablet');
  $(this).addClass('active').parents('li').siblings().find('a').removeClass('active');
  $('a[href="'+data_id+'"]').addClass('active').parents('li').siblings().find('a').removeClass('active');
  if (template == 'index' ){
    $('html, body').animate({
      scrollTop: $(data_id).offset().top - header_height
    }, 800);
    window.history.pushState({}, '', url);
    return false;
  }
  else{
    $(this).attr('href', url+data_id);
  }    
});